import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'team-management';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);


export const TOGGLE_LOADING = `${NAMESPACE}/TOGGLE_LOADING`;
export const INITIAL_DATA = createApiNamespacedConstants('initial_data');
export const INITIAL_USER_TABLE = createApiNamespacedConstants('initial_user_table');
